(() => {
  const priorities = {
    default: ['signature','premium','flute','essential','lisianthus','prestige25','prestige50','prestige100','elegance50','birthday_experience','romantic_experience'],
    birthday: ['premium','birthday_experience','romantic_experience','signature','lisianthus','essential','prestige25','flute','prestige50','prestige100'],
    anniversary: ['signature','prestige50','romantic_experience','prestige100','premium','prestige25','flute','lisianthus','essential'],
    birth: ['essential','premium','signature','lisianthus','flute','prestige25','prestige50'],
    apology: ['signature','premium','lisianthus','flute','essential','prestige25','prestige50'],
    love: ['prestige50','romantic_experience','signature','prestige100','premium','flute','prestige25','essential','lisianthus'],
    congratulations: ['lisianthus','prestige25','premium','birthday_experience','signature','prestige50','flute','essential','prestige100'],
    just_because: ['essential','flute','premium','lisianthus','signature','prestige25','prestige50']
  };
  const colorPriorities = {birth:['white','pink','peach','red'],love:['red','pink','peach','white'],anniversary:['red','pink','peach','white'],default:['red','pink','peach','white']};
  function selectProducts(products, selection) {
    const families = priorities[selection.occasion] || priorities.default;
    const colors = colorPriorities[selection.occasion] || colorPriorities.default;
    const seen = new Set();
    const matches = products.filter(product => {
      if (seen.has(product.id)) return false;
      seen.add(product.id);
      return (!selection.type || product.type === selection.type) && (!selection.color || product.colors.includes(selection.color));
    });
    function score(product) {
      const familyIndex = families.indexOf(product.family);
      const colorIndex = colors.findIndex(color => product.colors.includes(color));
      return (familyIndex < 0 ? 0 : 200 - familyIndex * 12) + (colorIndex < 0 ? 0 : 8 - colorIndex * 2);
    }
    matches.sort((a,b) => score(b) - score(a));
    const first = [], rest = [], used = new Set();
    matches.forEach(product => {
      if (used.has(product.family)) rest.push(product);
      else { used.add(product.family); first.push(product); }
    });
    return first.concat(rest);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {selectProducts};
  if (typeof document === 'undefined') return;
  function initialise(scope) {
    scope.querySelectorAll('[data-gift-finder]').forEach(root => {
      if (root.dataset.finderReady) return;
      const form = root.querySelector('[data-finder-form]');
      const groups = Array.from(root.querySelectorAll('[data-finder-group]'));
      const results = root.querySelector('[data-finder-results]');
      const grid = root.querySelector('[data-finder-grid]');
      const status = root.querySelector('[data-finder-status]');
      const empty = root.querySelector('[data-finder-empty]');
      const more = root.querySelector('[data-finder-more]');
      const reset = root.querySelector('[data-finder-reset]');
      const note = root.querySelector('[data-finder-color-note]');
      const selection = {occasion:'',type:'',color:''};
      const products = Array.from(root.querySelectorAll('[data-finder-product]')).map(template => ({id:template.dataset.productId,type:template.dataset.type,family:template.dataset.family,colors:template.dataset.colors.split(/\s+/).filter(Boolean),specialImages:template.dataset.specialImages?JSON.parse(template.dataset.specialImages):null,template}));
      let current = [], limit = 6;
      function updateChoices() {
        groups.forEach(group => group.querySelectorAll('button').forEach(button => {
          button.setAttribute('aria-pressed',String(selection[group.dataset.finderGroup] === button.dataset.value));
          button.disabled = false;
        }));
        note.hidden = selection.type !== 'experiences';
        reset.hidden = !Object.values(selection).some(Boolean);
      }
      function draw() {
        const visible = current.slice(0,limit);
        grid.dataset.visible = String(visible.length);
        grid.replaceChildren(...visible.map(product => {
          const fragment=product.template.content.cloneNode(true);
          const color=selection.color||'red';
          const specialImage=product.specialImages?.[color];
          if(specialImage){
            const image=fragment.querySelector('.qgf-card-photo img');
            image.src=specialImage.src;image.alt=specialImage.alt;image.removeAttribute('srcset');
            fragment.querySelectorAll('a').forEach(link=>{const url=new URL(link.href,location.origin);url.searchParams.set('cor',color);link.href=url.pathname+url.search+url.hash;});
          }
          return fragment;
        }));
        empty.hidden = current.length > 0;
        more.hidden = current.length <= visible.length;
        status.textContent = root.dataset.countTemplate.replace('__shown__',String(visible.length)).replace('__total__',String(current.length));
      }
      function render(moveFocus) {
        current = selectProducts(products,selection);
        root.querySelector('[data-finder-summary]').textContent = groups.map(group => {
          const selected = group.querySelector('[aria-pressed="true"]');
          return selected ? selected.textContent.trim() : '';
        }).filter(Boolean).join(' · ');
        results.hidden = false;
        draw();
        if (moveFocus) {
          const heading = root.querySelector('#qgf-results-title');
          heading.focus({preventScroll:true});
          results.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
        }
      }
      groups.forEach(group => group.querySelectorAll('button').forEach(button => button.addEventListener('click',() => {
        const key = group.dataset.finderGroup;
        selection[key] = selection[key] === button.dataset.value ? '' : button.dataset.value;
        limit = 6;
        updateChoices();
        if (!results.hidden) render(false);
      })));
      form.addEventListener('submit',event => {event.preventDefault();limit=6;render(true);});
      form.addEventListener('reset',() => {
        Object.keys(selection).forEach(key=>selection[key]='');
        limit=6;
        current=[];
        updateChoices();
        grid.replaceChildren();
        grid.removeAttribute('data-visible');
        status.textContent='';
        root.querySelector('[data-finder-summary]').textContent='';
        results.hidden=true;
        empty.hidden=true;
        more.hidden=true;
        form.querySelector('[type="submit"]').focus({preventScroll:true});
      });
      more.addEventListener('click',() => {limit+=6;draw();});
      root.dataset.finderReady = 'true';
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load',event => initialise(event.target));
})();
